import React from "react";
import VoucherBuilderGeneral from './VoucherBuilderGeneral';
import VoucherBuilderPurchasePaymentDataTable from './VoucherBuilderPurchasePaymentDataTable';
import VoucherBuilderPayoutPaymentsDataTable from './VoucherBuilderPayoutPaymentsDataTable';
import NoteBuilder from "../NoteBuilder/NoteBuilder";
import DataTable from '../DataTable/DataTable';
import EmailTab from "./EmailTab";

const VoucherBuilderWorkspace = (props) => {
  return (
    <div className='tab-content'>
      { props.activeTab == 'general' ? <VoucherBuilderGeneral {...props} /> : null }
      {props.activeTab == 'purchasePayment' ? <VoucherBuilderPurchasePaymentDataTable {...props} /> : null }
      {props.activeTab == 'voucherPayments' ? <VoucherBuilderPayoutPaymentsDataTable {...props} /> : null }
      {props.activeTab == 'emails' ? <EmailTab {...props} /> : null }
      {
        props.activeTab == 'notes' && props.new_record
        ? 
        <NoteBuilder note={props.noteObj} new_record={true} onChangeNote={props.changeNoteObj} onChangeFileUploadGroup={props.changeNoteObj} onChangeFlagged={props.changeNoteObj} ok_to_edit={true} buttons={props.buttons}/>
        :
          null
      }
      {
        props.activeTab == 'notes' && !props.new_record
        ?
          <DataTable endpoint={props.voucher_notes_path} updateNoteCount={props.updateNoteCount} date_format={props.date_format} time_format={props.time_format} no_data_text={I18n.t('none')} />
        :
          null
      }
    </div>
  );
};

export default VoucherBuilderWorkspace;
